var exports = {
  "kL": "x43aef4ae--3effe5--container",
  "_N": "x43aef4ae--3effe5--stretch",
  "g0": "x43aef4ae--3effe5--v2-design",
};

module.exports = exports;
